import { LoaderV2 } from "#src/commonV2/LoadingState";
import { TAILWIND_COLORS } from "#src/utils/common";
import { Tooltip } from "@lockerpm/design";
import { ArrowUpRight, InfoCircle } from "@untitled-ui/icons-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link, To } from "react-router-dom";

interface IBillingOverviewCardProps {
  title: ReactNode;
  hint?: ReactNode;
  linkTo: To | null;
  value: number | null;
  bgTwColor: string;
  markerTwColor: string;
}

export const BillingOverviewCard = ({
  title,
  hint,
  linkTo,
  value,
  bgTwColor,
  markerTwColor,
}: IBillingOverviewCardProps) => {
  const { t } = useTranslation("workspace", {
    keyPrefix: "billing.overviewCard",
  });

  return (
    <div
      className={`py-2 flex items-center justify-between rounded-xl ${bgTwColor} min-h-24`}
    >
      <div className="px-6 flex flex-col gap-1">
        <div className="flex items-center gap-2 text-gray-v2-900 text-lg font-medium">
          {title}
          {hint ? (
            <Tooltip
              color={TAILWIND_COLORS["gray-v2-900"]}
              title={
                <p className="text-xs text-white font-semibold text-center">
                  {hint}
                </p>
              }
            >
              <InfoCircle className="h-5 w-5 min-w-5 text-gray-v2" />
            </Tooltip>
          ) : null}
        </div>
        {linkTo !== null ? (
          <Link
            to={linkTo}
            className="flex items-center gap-1 text-brand-v2-700 text-sm font-semibold no-underline"
          >
            {t("viewNow")}
            <ArrowUpRight className="h-5 w-5 min-w-5" />
          </Link>
        ) : null}
      </div>
      <div className="px-6 py-3 relative text-display-sm font-semibold text-gray-v2-900 whitespace-nowrap">
        {value === null ? (
          <LoaderV2 baseSize={1} />
        ) : (
          value.toString().padStart(2, "0")
        )}
        {/* Marker. For the sake of beauty. */}
        <span
          className={`absolute right-0 top-0 bottom-0 my-auto h-10 w-1.5 rounded-l-full ${markerTwColor}`}
        />
        {/* Marker end */}
      </div>
    </div>
  );
};
